"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.securityAuthenticationWatchers = exports.securityAuthenticationReducers = void 0;
const xuder_1 = require("@sonar-software/xuder");
const redux_1 = require("redux");
const change_email_1 = require("./change-email/index.js");
const enroll_1 = require("./enroll/index.js");
const forgot_password_1 = require("./forgot-password/index.js");
const login_1 = require("./login/index.js");
const reset_password_1 = require("./reset-password/index.js");
exports.securityAuthenticationReducers = (0, redux_1.combineReducers)({
    changeEmail: change_email_1.securityAuthenticationChangeEmailReducers,
    enroll: enroll_1.securityAuthenticationEnrollReducers,
    forgotPassword: forgot_password_1.securityAuthenticationForgotPasswordReducers,
    login: login_1.securityAuthenticationLoginReducers,
    resetPassword: reset_password_1.securityAuthenticationResetPasswordReducers
});
exports.securityAuthenticationWatchers = (0, xuder_1.combineAllWatchers)([
    change_email_1.securityAuthenticationChangeEmailWatchers,
    enroll_1.securityAuthenticationEnrollWatchers,
    forgot_password_1.securityAuthenticationForgtoPasswordWatchers,
    login_1.securityAuthenticationLoginWatchers,
    reset_password_1.securityAuthenticationResetPasswordWatchers
]);
//# sourceMappingURL=index.js.map